/**
 * PDP countdown (D:H:M:S). Same end-time parsing as collection-activity (Pacific -08:00).
 * Root: [data-mm-countdown] with data-end / data-end-epoch
 * Each unit displays as 2 digits. Remaining time loops every 72 hours (max 3 days).
 */
(function () {
  function pad2(n) {
    var v = Math.max(0, Math.floor(n));
    if (v > 99) v = 99;
    return v < 10 ? '0' + v : String(v);
  }

  function clearTimer(root) {
    if (!root) return;
    var id = root._mmCountdownIntervalId;
    if (id != null) {
      window.clearInterval(id);
      root._mmCountdownIntervalId = null;
    }
  }

  function updateCountdownValue(element, value) {
    if (!element || element.textContent === value) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      element.textContent = value;
      return;
    }

    var parent = element.parentNode;
    if (!parent) {
      element.textContent = value;
      return;
    }

    // Clear unfinished outgoing frames so seconds never stack.
    var stale = parent.querySelectorAll('.mm-countdown-value--outgoing');
    Array.prototype.forEach.call(stale, function (node) {
      node.remove();
    });

    var outgoing = document.createElement('span');
    outgoing.className = 'mm-countdown-value--outgoing';
    outgoing.setAttribute('aria-hidden', 'true');
    outgoing.textContent = element.textContent;
    parent.insertBefore(outgoing, element);

    element.textContent = value;
    element.classList.remove('mm-countdown-value--incoming');
    void element.offsetWidth;
    element.classList.add('mm-countdown-value--incoming');

    outgoing.addEventListener(
      'animationend',
      function () {
        outgoing.remove();
      },
      { once: true }
    );
  }

  function parsePacificFixedTimeToMs(raw) {
    var value = (raw || '').trim();
    if (!value) return NaN;

    var normalized = value.replace(' ', 'T');
    if (!/T/.test(normalized)) normalized += 'T00:00:00';
    if (/T\d{2}$/.test(normalized)) normalized += ':00:00';
    else if (/T\d{2}:\d{2}$/.test(normalized)) normalized += ':00';

    normalized = normalized.replace(/(Z|[+\-]\d{2}:?\d{2})$/i, '');
    return new Date(normalized + '-08:00').getTime();
  }

  function initCountdown(root) {
    if (!root || root.getAttribute('data-mm-countdown-init') === '1') return;

    var endStr = (root.getAttribute('data-end') || '').trim();
    if (!endStr) return;

    var endMs = parsePacificFixedTimeToMs(endStr);
    if (!Number.isFinite(endMs)) {
      var endEpochAttr = (root.getAttribute('data-end-epoch') || '').trim();
      var endEpochSec = parseInt(endEpochAttr, 10);
      endMs = Number.isFinite(endEpochSec) && endEpochSec > 0 ? endEpochSec * 1000 : NaN;
    }
    if (!Number.isFinite(endMs)) return;

    var elD = root.querySelector('[data-mm-countdown-d]');
    var elH = root.querySelector('[data-mm-countdown-h]');
    var elM = root.querySelector('[data-mm-countdown-m]');
    var elS = root.querySelector('[data-mm-countdown-s]');
    if (!elD || !elH || !elM || !elS) return;

    root.setAttribute('data-mm-countdown-init', '1');

    function tick() {
      var CYCLE_SEC = 72 * 3600;
      var leftSec = Math.floor((endMs - Date.now()) / 1000);
      if (leftSec <= 0) {
        updateCountdownValue(elD, pad2(0));
        updateCountdownValue(elH, pad2(0));
        updateCountdownValue(elM, pad2(0));
        updateCountdownValue(elS, pad2(0));
        clearTimer(root);
        return;
      }

      var displaySec = leftSec % CYCLE_SEC;
      if (displaySec === 0) displaySec = CYCLE_SEC;

      var d = Math.floor(displaySec / 86400);
      var h = Math.floor((displaySec % 86400) / 3600);
      var m = Math.floor((displaySec % 3600) / 60);
      var s = displaySec % 60;
      updateCountdownValue(elD, pad2(d));
      updateCountdownValue(elH, pad2(h));
      updateCountdownValue(elM, pad2(m));
      updateCountdownValue(elS, pad2(s));
    }

    tick();
    root._mmCountdownIntervalId = window.setInterval(tick, 1000);
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mm-countdown]'), initCountdown);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    var nodes = event.target.querySelectorAll
      ? event.target.querySelectorAll('[data-mm-countdown]')
      : [];
    Array.prototype.forEach.call(nodes, function (node) {
      clearTimer(node);
      node.removeAttribute('data-mm-countdown-init');
    });
  });

  window.mmCountdownBoot = boot;
  window.mmCountdownClear = clearTimer;
})();
